<mat-toolbar>
    <span>Properties</span>
    <span class="info-drawer-toolbar-spacer"></span>
    <button mat-icon-button (click)="cancelClicked()" tabindex="-1"><mat-icon>close</mat-icon></button>
</mat-toolbar>
<div class="form-properties">
    <div class="historyPanel mat-small">
        <div *ngIf="form.createdDate">
            <strong>created</strong> {{ form.createdDate | date: 'MMM d, YYYY, h:mm:ss a' }}
            <span *ngIf="form.createdByUserName"><br />by {{ form.createdByUserName }}</span>
        </div>
        <div *ngIf="form.modifiedDate > form.createdDate">
            <strong>modified</strong> {{ form.modifiedDate | date: 'MMM d, YYYY, h:mm:ss a' }}
            <span *ngIf="form.modifiedByUserName"><br />by {{ form.modifiedByUserName }}</span>
        </div>
    </div>
    <div>
        <span *ngIf="form.formInstanceCount == 0">This template is not used by any forms.</span>
        <span *ngIf="form.formInstanceCount == 1">This template is used by one form.</span>
        <span *ngIf="form.formInstanceCount > 1">This template is used by {{ form.formInstanceCount }} forms.</span>
    </div>
    <br />
    <!-- Selection for the number of cells, by default, for each row.-->
    <div class="control-wrapper" id="formDefaultColumnCountDiv">
        <mat-label>Number of Columns</mat-label>
        <mat-button-toggle-group [(ngModel)]="form.formLayout.columnsDefault">
            <mat-button-toggle [value]="1"
                               aria-label="One Column"
                               [disabled]="1 < this.MaxCellColSpan"
                               matTooltip="{{this.ColumnCountTooltip(1)}}"
                               [matTooltipPosition]="this.TooltipPosition">
                1
            </mat-button-toggle>
            <mat-button-toggle [value]="2"
                               aria-label="Two Columns"
                               [disabled]="2 < this.MaxCellColSpan"
                               matTooltip="{{this.ColumnCountTooltip(2)}}"
                               [matTooltipPosition]="this.TooltipPosition">
                2
            </mat-button-toggle>
            <mat-button-toggle [value]="3"
                               aria-label="Three Columns"
                               [disabled]="3 < this.MaxCellColSpan"
                               matTooltip="{{this.ColumnCountTooltip(3)}}"
                               [matTooltipPosition]="this.TooltipPosition">
                3
            </mat-button-toggle>
            <mat-button-toggle [value]="4"
                               aria-label="Four Columns"
                               matTooltip="{{this.ColumnCountTooltip(4)}}"
                               [matTooltipPosition]="this.TooltipPosition">
                4
            </mat-button-toggle>
        </mat-button-toggle-group>
        <small>The number of columns in the form layout</small>
    </div>
    <!-- The form's layout style. -->
    <div class="control-wrapper" id="formAlignmentDiv">
        <mat-label>Column Layout</mat-label>
        <mat-button-toggle-group [(ngModel)]="form.formLayout.alignment">
            <mat-button-toggle value="justify" aria-label="All Same Width">
                <mat-icon>format_align_justify</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="left" aria-label="Large Column Left" [disabled]="this.form.formLayout.columnsDefault == 1">
                <mat-icon>format_align_left</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="center" aria-label="Large Column Center" [disabled]="this.form.formLayout.columnsDefault < 3">
                <mat-icon>format_align_center</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="right" aria-label="Large Column Right" [disabled]="this.form.formLayout.columnsDefault == 1">
                <mat-icon>format_align_right</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
        <small>Uniform width or align largest column left, center, or right</small>
    </div>

    <mat-checkbox [(ngModel)]="form.alwaysShowCellSelection"
                  (click)="ToggleAlwaysShowCellSelectionIsModified()">Always show selection check boxes</mat-checkbox>
    <mat-checkbox [(ngModel)]="form.hideSaveButton">Hide Save button</mat-checkbox>
    <mat-checkbox [(ngModel)]="form.confirmSavePopup">Confirm Save with Popup</mat-checkbox>
    <mat-checkbox [(ngModel)]="form.enableBulkWorkflow">Enable Bulk Workflow Transition</mat-checkbox>
    <br />
    <span>Save Button Caption:</span>
    <input id="saveButtonCaption"
           [(ngModel)]="form.saveButtonCaption"
           type="text"
           placeholder="Enter save button caption"
           style="width:100%">
    <br /><br />

    <!-- The workflow to use for this form's instances. -->
    <div class="control-wrapper">
        <mat-label>Workflow</mat-label> <!-- Added 02-24-2021. -->
        <mat-form-field appearance="outline" [floatLabel]="'always'">
            <mat-select [(ngModel)]="form.workflowId">
                <mat-option *ngFor="let wf of this.SiteWorkflows" [value]="wf.id">
                    {{wf.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <!-- 07-11-2024 note:  added the following, optional auto-form number configuration infromation. -->
    <div class="control-wrapper">
        <h5>Form Auto-numbering</h5>

        <mat-checkbox [checked]="form.suggestAutonumberFormNames"
                      (change)="this.suggestAutonumberFormNamesChanged($event)"
                      class="suggested-form-names-checkbox">
            Suggest auto-numbered form name?
        </mat-checkbox>
        <mat-checkbox *ngIf="form.suggestAutonumberFormNames"
                      [checked]="form.prefixFormNameWithFolderName"
                      (change)="this.prefixFormNameWithFolderNameChanged($event)"
                      class="suggested-form-names-checkbox">
            Prefix name with folder name?
        </mat-checkbox>
        <div *ngIf="form.suggestAutonumberFormNames" class="suggested-name-div">
            <span class="name-prefix-span">Name Prefix:</span>
            <input matInput
                   type="text"
                   [formControl]="this.SuggestedFormNamePrefix_FormControl"
                   placeholder="Enter a name prefix"
                   class="suggested-form-name-prefix-mat-input" />
        </div>
        <br />
        <span *ngIf="this.ExampleSuggestedFormName">Example form name (for the fifth form):</span>
        <span class="example-suggested-form-name-span">{{this.ExampleSuggestedFormName}}</span>
    </div>
    <div id="dialogActionsDiv"
         class="button-wrapper">
        <button mat-flat-button color="primary" class="theme-primary-btn" (click)="saveClicked()">OK</button>
        <button mat-flat-button color="basic" (click)="cancelClicked()">Cancel</button>
    </div>
</div>
